import { render, staticRenderFns } from "./AlarmHistoryApp.vue?vue&type=template&id=038824a3&scoped=true&"
import script from "./AlarmHistoryApp.vue?vue&type=script&lang=js&"
export * from "./AlarmHistoryApp.vue?vue&type=script&lang=js&"
import style0 from "./AlarmHistoryApp.vue?vue&type=style&index=0&id=038824a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038824a3",
  null
  
)

export default component.exports